import { useFrame } from '@react-three/fiber'
import { useGLTF, useTexture } from '@react-three/drei'
import { easing } from 'maath'
import { useLoader } from '@react-three/fiber'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { useRef, useMemo } from 'react'
import { ribPatterns } from '../../textures';
import * as THREE from 'three'
import { TextureLoader } from 'three'
import React from 'react'


const Ribs = ({ model, neededRibs, tiles }) => {
    const snap = useSnapshot(state.current)
    const { nodes, materials } = useGLTF(model)

    // Normal texture setup
    const ribNormalTexture = useTexture(ribPatterns.normal)
    useMemo(() => {
        ribNormalTexture.repeat.set(3, 1)
        ribNormalTexture.wrapS = THREE.RepeatWrapping
        ribNormalTexture.wrapT = THREE.RepeatWrapping
        ribNormalTexture.needsUpdate = true
    }, [ribNormalTexture])

    // Dynamic texture loading based on neededRibs
    const ribTextures = useLoader(
        TextureLoader,
        Array.from({ length: neededRibs }, (_, i) => {
            const rib = snap.choices.ribs.selected.rib[i]
            return ribPatterns[rib?.src]
        })
    )

    // Create refs dynamically
    const ribRefs = useRef([]);

    // Ensure refs array matches rib count
    while (ribRefs.current.length < neededRibs) {
        ribRefs.current.push(React.createRef());
    }
    ribRefs.current = ribRefs.current.slice(0, neededRibs);

    // Apply texture settings
    useMemo(() => {
        ribTextures.forEach(t => {
            t.repeat.set(tiles, tiles)
            t.wrapS = THREE.RepeatWrapping
            t.wrapT = THREE.RepeatWrapping
            t.needsUpdate = true
        })
    }, [ribTextures])

    // Animate material colors
    useFrame((_, delta) => {
        for (let i = 0; i < neededRibs; i++) {
            const colorProp = materials[`RibColor${i + 1}`]?.color
            const targetHex = snap.choices.ribs.selected.rib[i]?.hex
            if (colorProp && targetHex) {
                easing.dampC(colorProp, targetHex, 0.1, delta)
            }
        }
    })

    return (
        <>
            {Array.from({ length: neededRibs }).map((_, i) => {

                const geometry = i === 0 ? nodes["Mesh"].geometry : nodes[`Mesh_${i}`]?.geometry;
                const material = materials[`RibColor${i + 1}`]
                // console.log(material)

                return (
                    <mesh key={i} geometry={geometry} material={material}>
                        {
                            snap.choices.ribs.selected.rib[i].src && (
                                <meshStandardMaterial
                                    map={ribTextures[i]}
                                    ref={ribRefs.current[i]}
                                    normalMap={ribNormalTexture.normalMap}
                                    normalScale={new THREE.Vector2(1, 5)}
                                    roughness={0.8}
                                    metalness={0.15}
                                    side={THREE.DoubleSide}
                                />
                            )}
                    </mesh>
                )
            })}
        </>
    )
}

export default Ribs

